import * as React from 'react';
import { FormControl } from '@common/components/form-control';

import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Input.styles.scss';

export const Input = (props) => {
  const { value, defaultValue, className, index, id, autoFocus, placeholder, metadata, onSave, validateValue, normalizeBeforeSave } = props;
  const normalizedValue = value || defaultValue || '';
  const [savedValue, setSavedValue] = React.useState(normalizedValue);
  const [currentValue, setCurrentValue] = React.useState(normalizedValue);

  React.useEffect(() => {
    setSavedValue(normalizedValue);
    setCurrentValue(normalizedValue);
  }, [index, value, id]);
  
  const handleChange = React.useCallback((e) => {
    e.persist();

    const { value } = e.target;

    if (validateValue(value)) {
      setCurrentValue(value);
    }
  }, [validateValue]);

  const save = React.useCallback(async () => {
    const normalizedValue = normalizeBeforeSave(currentValue);

    try {
      await onSave({
        index,
        id,
        savedValue,
        value: normalizedValue,
        metadata,
      });

      setSavedValue(normalizedValue);
      setCurrentValue(normalizedValue);
    } catch (err) {
      setCurrentValue(savedValue);
    }
  }, [currentValue, index, id, savedValue, onSave]);

  return (
    <FormControl
      autoFocus={autoFocus}
      placeholder={placeholder}
      id={`${LOOKUP_MODULE_NAME}-input--id-${id}--index-${index}`}
      title={currentValue}
      className={className}
      type="text"
      value={currentValue}
      onChange={handleChange}
      onBlur={save}
    />
  );
};

Input.defaultProps = {
  defaultValue: '',
  validateValue: () => true,
  normalizeBeforeSave: (value) => value
};